import React, { useEffect, useState } from "react";
import { useIsAuthenticated } from "@azure/msal-react";
import { Container, Row } from "react-bootstrap";
import { Box, Typography } from "@mui/material";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import { ShopCenterPagination } from "../shop/ShopCenterPagination";
import { OrdersList } from "./OrdersList";
import { ListSkeleton } from "../common/Skeletons";
import { EmptyState } from "../common/EmptyState";

import '../../styles/Orders.scss';

import OrdersService from "../../services/ordersService";
import { Header } from "../common/Header";
import { TopBar } from "../common/TopBar";



/**
 * Renders information about the user obtained from MS Graph
 * @param props 
 */
export const Orders = (props) => {

    let ordersBase = {
        result: [],
        pages: [],
        totalPages: 0,
        totalCount: 0,
        page: 1,
        pageSize: 30
    };



    const orderService = OrdersService();
    const [orders, setOrders] = useState(ordersBase);
    const [orderLoaded, setOrderLoaded] = useState(false);
    const [filter, setFilter] = useState({
        page: ordersBase.page,
        pageSize: ordersBase.pageSize,
    });

    const [totPages, setTotPages] = useState(0);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(30);

    const [showPending, setShowPending] = useState(false);
    const [pendingOrders, setPendingOrders] = useState([]);

    const [showItem, setShowItem] = useState(false);

    useEffect(() => {

        const initState = async () => {
            setOrderLoaded(false);
            const allOrders = await orderService.getOrders(filter.page, filter.pageSize);
            setOrders(allOrders);
            ordersBase = allOrders;
            setTotPages(allOrders.totalPages);
            setPage(allOrders.page);
            setPageSize(allOrders.pageSize);
            setFilter({
                totalCount: allOrders.totalCount,
                totalPages: allOrders.totalPages,
                page: allOrders.page,
                pageSize: allOrders.pageSize,
                pages: allOrders.pages,
            });
            updateOrders(1);
        };
        initState();
    }, []);

    const updateOrders = async (a) => {
        setOrderLoaded(false);
        const newOrders = await orderService.getOrders(a, pageSize);

        setOrders(newOrders);
        ordersBase = newOrders;
        setTotPages(newOrders.totalPages);
        setPage(newOrders.page);
        setPageSize(newOrders.pageSize);
        setFilter({
            totalCount: ordersBase.totalCount,
            totPages: ordersBase.totalPages,
            page: ordersBase.page,
            pageSize: ordersBase.pageSize,
        });

        setOrderLoaded(true);
        setShowItem(false);
    }

    const onPageChange = (newPage) => {
        if (page != newPage) {
            console.log("onPageChange", newPage, page);
            console.log("showPending", showPending);
            setPage(newPage);

            updateOrders(newPage);
            setShowItem(false);
            setOrderLoaded(true);
        }
    };


    const isLoading = !orderLoaded;
    return (
        <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
            <Header />
            <TopBar />
            <Box sx={{ px: { xs: 2, md: 4 }, py: 3 }}>
                {!showItem && (
                    <Typography variant="h5" align="center" sx={{ fontWeight: 800, mb: 3 }}>
                        Posted Orders
                    </Typography>
                )}
                {!showItem && orderLoaded && orders.totalCount > 0 && (
                    <Container>
                        <Row>
                            <ShopCenterPagination
                                totPages={totPages}
                                currentPage={page}
                                pageClicked={(ele) => onPageChange(ele)}
                            />
                        </Row>
                    </Container>
                )}
                {isLoading && !showItem ? (
                    <ListSkeleton rows={6} columns={6} />
                ) : orders.totalCount > 0 ? (
                    <OrdersList
                        orders={orders}
                        filter={filter}
                        onPageChange={onPageChange}
                        showItem={showItem}
                        setShowItem={setShowItem}
                    />
                ) : !showItem ? (
                    <EmptyState
                        icon={<LocalShippingOutlinedIcon />}
                        title="No posted orders yet"
                        description="Once your orders are posted by our team they will appear here."
                    />
                ) : null}
            </Box>
        </Box>
    );
};